package aexorsa

import tanstack.react.router.RootRouteOptions
import tanstack.react.router.RouteOptions
import tanstack.react.router.Router
import tanstack.react.router.RouterOptions
import tanstack.react.router.createRootRoute
import tanstack.react.router.createRoute
import tanstack.react.router.createRouter
import tanstack.router.core.RoutePath

fun createAppRouter(): Router {
    val rootRoute = createRootRoute(
        options = RootRouteOptions(),
    )
    val homeRoute = createRoute(
        options = RouteOptions(
            getParentRoute = { rootRoute },
            path = RoutePath("/"),
            component = LandingPage,
        ),
    )
    rootRoute.addChildren(arrayOf(homeRoute))

    return createRouter(
        options = RouterOptions(
            routeTree = rootRoute,
        ),
    )
}
